var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"color":_vm.color,"name":_vm.name,"disabled":_vm.isDisabled,"text":_vm.isText},on:{"click":function($event){return _vm.isPushButton(_vm.name)}}},[_vm._v(" "+_vm._s(_vm.value)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }